define("settings/components/subscription-overview/action", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Section::ItemAction data-test-id="subscription-overview-action">
    {{#if @subscription}}
      {{#if @isAccountOwner}}
        {{#if (and @hasActiveTrial (not @hasActiveCancelledSubscription))}}
          <Shared::Ui::Button
            class="u--m__b__lg u--m__t__md u--m__r"
            @type="outline"
            @additional="block"
            @text={{t "account.overview.subscription_overview.cancel_trial"}}
            @onClick={{@cancelTrial}}
          />
        {{else if (and @hasActiveCancelledSubscription @canReactivatePlan)}}
          <Shared::Ui::Button
            class="u--m__b__lg u--m__t__md u--m__r"
            @type="proceed"
            @additional="block"
            @text={{t "account.overview.subscription_overview.reactivate_plan"}}
            @promise={{@reactivatePlan}}
          />
          {{#if @isNewSubscriber}}
            <Shared::Link
              class="u--m__r u--text--right u--block u--p__t"
              @href="https://later.com/product-training/"
              @text={{t "account.overview.subscription_overview.help"}}
              {{on "click" @trackClickedTraining}}
            />
          {{/if}}
        {{else if @canUpgrade}}
          <Shared::Button::Upgrade
            class="u--m__r qa--settings__button--upgrade"
            @location="subscription overview"
            @text={{t "shared_phrases.upgrade_plan"}}
            @feature="trialPlansSnapshot"
          />
        {{else}}
          <Shared::Button::Upgrade
            class="u--m__r qa--subscription__button--changePlan"
            @type="outline"
            @location="subscription overview"
            @text={{t "account.overview.subscription_overview.change_plan"}}
            @feature="plans"
            {{on "click" @trackChangePlan}}
          />
        {{/if}}
      {{/if}}
    {{else}}
      <Shared::Button::Upgrade
        class="u--m__r qa--settings__button--upgrade"
        @location="subscription overview"
        @text={{t "shared_phrases.upgrade_plan"}}
        @feature="trialPlansSnapshot"
      />
    {{/if}}
  </Section::ItemAction>
  
  */
  {
    "id": "OPjqR2gs",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"subscription-overview-action\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,1],[[[41,[30,2],[[[41,[28,[37,2],[[30,3],[28,[37,3],[[30,4]],null]],null],[[[1,\"        \"],[8,[39,4],[[24,0,\"u--m__b__lg u--m__t__md u--m__r\"]],[[\"@type\",\"@additional\",\"@text\",\"@onClick\"],[\"outline\",\"block\",[28,[37,5],[\"account.overview.subscription_overview.cancel_trial\"],null],[30,5]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,2],[[30,4],[30,6]],null],[[[1,\"        \"],[8,[39,4],[[24,0,\"u--m__b__lg u--m__t__md u--m__r\"]],[[\"@type\",\"@additional\",\"@text\",\"@promise\"],[\"proceed\",\"block\",[28,[37,5],[\"account.overview.subscription_overview.reactivate_plan\"],null],[30,7]]],null],[1,\"\\n\"],[41,[30,8],[[[1,\"          \"],[8,[39,6],[[24,0,\"u--m__r u--text--right u--block u--p__t\"],[4,[38,7],[\"click\",[30,9]],null]],[[\"@href\",\"@text\"],[\"https://later.com/product-training/\",[28,[37,5],[\"account.overview.subscription_overview.help\"],null]]],null],[1,\"\\n\"]],[]],null]],[]],[[[41,[30,10],[[[1,\"        \"],[8,[39,8],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@location\",\"@text\",\"@feature\"],[\"subscription overview\",[28,[37,5],[\"shared_phrases.upgrade_plan\"],null],\"trialPlansSnapshot\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,8],[[24,0,\"u--m__r qa--subscription__button--changePlan\"],[4,[38,7],[\"click\",[30,11]],null]],[[\"@type\",\"@location\",\"@text\",\"@feature\"],[\"outline\",\"subscription overview\",[28,[37,5],[\"account.overview.subscription_overview.change_plan\"],null],\"plans\"]],null],[1,\"\\n      \"]],[]]]],[]]]],[]]]],[]],null]],[]],[[[1,\"    \"],[8,[39,8],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@location\",\"@text\",\"@feature\"],[\"subscription overview\",[28,[37,5],[\"shared_phrases.upgrade_plan\"],null],\"trialPlansSnapshot\"]],null],[1,\"\\n\"]],[]]]],[]]]]],[1,\"\\n\"]],[\"@subscription\",\"@isAccountOwner\",\"@hasActiveTrial\",\"@hasActiveCancelledSubscription\",\"@cancelTrial\",\"@canReactivatePlan\",\"@reactivatePlan\",\"@isNewSubscriber\",\"@trackClickedTraining\",\"@canUpgrade\",\"@trackChangePlan\"],false,[\"section/item-action\",\"if\",\"and\",\"not\",\"shared/ui/button\",\"t\",\"shared/link\",\"on\",\"shared/button/upgrade\"]]",
    "moduleName": "settings/components/subscription-overview/action.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});